module.exports = __webpack_public_path__ + "static/img/book.c1a5da8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book.png
// module id = jWGT
// module chunks = 1